import {camelCase} from 'change-case';
import {clone, merge} from 'lodash';

// Pure reducer extracted from state.js so it can be unit-tested
// without spinning up React. Handles authenticate, breadcrumb push
// (with URL synthesis + dedupe + 5-entry cap), and clear.
export function reducer(state, action) {
    switch (action.type) {
        case 'authenticate':
            return Object.assign(state, {username: action.username, role: action.role, accessToken: action.accessToken});
        case 'add-breadcrumb-entry':
            state.breadcrumb = state.breadcrumb || [];
            action.entry.title = action.entry.title || camelCase(action.entry.modelKey || action.entry.intfKey);
            // Apply the version default BEFORE building the URL so a
            // missing version doesn't bake the literal string
            // 'undefined' into the path.
            action.entry.version = action.entry.version || 'latest';
            action.entry.url =
                action.entry.url ||
                `/${action.entry.env}/standards/${action.entry.category}/${action.entry.key}/${action.entry.version}/${action.entry.linkType || 'models'}/${
                    action.entry.modelKey || action.entry.intfKey
                }`;

            const existingEntryIndex = state.breadcrumb.findIndex((e) => e.url === action.entry.url);
            if (existingEntryIndex !== -1) {
                state.breadcrumb.splice(existingEntryIndex + 1);
            } else {
                state.breadcrumb.push(action.entry);
            }
            if (state.breadcrumb.length > 5) {
                state.breadcrumb.shift();
            }
            return clone(merge(state, {breadcrumb: state.breadcrumb}));
        case 'clear-breadcrumb':
            state.breadcrumb = [];
            return clone(state);
        default:
            throw new Error('invalid action');
    }
}
